import { observer } from 'mobx-react'
import { useState } from 'react'

import { Button } from '@avantstay/backoffice-core'

import * as S from './AsyncHotelFilter.styles'
import { AsyncHotelFilterProps } from './AsyncHotelFilter.types'
import { HotelsList } from './components/HotelsList'
import { asyncHotelFilterStore } from './stores/AsyncHotelFilterStore'

const _AsyncHotelFilterMenu = ({ initialValue, onChange }: AsyncHotelFilterProps) => {
  const { hotelOptions, isLoading } = asyncHotelFilterStore

  const [selectedHotelId, setSelectedHotelId] = useState(initialValue)

  const handleApply = () => {
    if (selectedHotelId) {
      onChange(selectedHotelId)
    }
  }

  return (
    <S.MenuContainer>
      <S.MenuTitle>Select the hotel to proceed</S.MenuTitle>

      <S.MenuContent>
        <HotelsList
          options={hotelOptions}
          initialValue={initialValue}
          isLoadingOptions={isLoading}
          onChange={setSelectedHotelId}
        />
      </S.MenuContent>

      <div>
        <Button.Primary disabled={!selectedHotelId} onClick={handleApply}>
          Apply
        </Button.Primary>
      </div>
    </S.MenuContainer>
  )
}

export const AsyncHotelFilterMenu = observer(_AsyncHotelFilterMenu)
